import React, { useState } from "react";
import DashboardSidebar from "./DashboardSidebar";
import VendorHeader from "./VendorHeader";
import { Outlet } from "react-router-dom";
import { useDarkMode } from "../Context/DarkModeContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const ReactQueryDevtools = import.meta.env.DEV
  ? React.lazy(() =>
      import("@tanstack/react-query-devtools").then((mod) => ({
        default: mod.ReactQueryDevtools,
      }))
    )
  : () => null;
import { ChatWidget } from "./VendorCustomerCare/CustomerCareWidget";



const VendorLayout: React.FC = () => {
  const { darkMode } = useDarkMode(); 
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Reuse cached data across remounts instead of refetching on every
            // mount; individual queries still override this where needed.
            staleTime: 60_000,
            gcTime: 5 * 60_000,
            // Stop the flood of refetches every time the tab regains focus.
            refetchOnWindowFocus: false,
            retry: 1,
          },
        },
      })
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <QueryClientProvider client={queryClient}>
      <div className={darkMode ? "dark" : ""}>
        <div className="flex h-screen">
          
          <DashboardSidebar 
            darkMode={darkMode} 
            isOpen={isSidebarOpen} 
            onClose={() => setIsSidebarOpen(false)}
          />

          {/* Main Content */}
          <div className="flex min-w-0 flex-col flex-1">
            {/* Header */}
            <VendorHeader onToggleSidebar={() => setIsSidebarOpen((v) => !v)} />{" "}
           
            <main className="flex-1 p-4 overflow-y-auto text-gray-900 bg-gray-50 dark:bg-gray-900 dark:text-gray-100">
              <Outlet />

              <span className="text-lg font-bold text-white">
                <ChatWidget />
              </span>
            </main>
          </div>
        </div>
        {isSidebarOpen && (
          <div
            className="fixed inset-0 z-30 bg-black/40 md:hidden"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}
      </div>
      <React.Suspense fallback={null}>
        <ReactQueryDevtools initialIsOpen={false} />
      </React.Suspense>
    </QueryClientProvider>
  );
};

export default VendorLayout;
